import { readUserDetails } from '@/utils/auth-token-store';
/**
 * `<org>:<user>` for the signed-in recruiter, or null when unknown. Used to keep
 * device-stored state (drafts, tour progress) apart between accounts on one browser.
 */
export function accountScope() {
    var _a, _b, _c, _d;
    try {
        const raw = readUserDetails() || localStorage.getItem('user-details');
        if (!raw)
            return null;
        const user = JSON.parse(raw);
        const org = (_b = (_a = user === null || user === void 0 ? void 0 : user.organization_id) !== null && _a !== void 0 ? _a : user === null || user === void 0 ? void 0 : user.org_id) !== null && _b !== void 0 ? _b : user === null || user === void 0 ? void 0 : user.iam_organization_id;
        const person = (_d = (_c = user === null || user === void 0 ? void 0 : user.representative_details) === null || _c === void 0 ? void 0 : _c.representative_id) !== null && _d !== void 0 ? _d : user === null || user === void 0 ? void 0 : user.email;
        return org && person ? `${org}:${person}` : null;
    }
    catch (_e) {
        return null;
    }
}
